import { render, staticRenderFns } from "./ProductImagesLogs.vue?vue&type=template&id=07211de1"
import script from "./ProductImagesLogs.vue?vue&type=script&lang=js"
export * from "./ProductImagesLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports